import { render } from "./MatrixRenderer.vue?vue&type=template&id=87237fb2&scoped=true"
import script from "./MatrixRenderer.vue?vue&type=script&lang=js"
export * from "./MatrixRenderer.vue?vue&type=script&lang=js"

import "./MatrixRenderer.vue?vue&type=style&index=0&id=87237fb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87237fb2"]])

export default __exports__